import Model, { AsyncHasMany, attr, hasMany } from '@ember-data/model';
import config from 'admin-panel/config/environment';
import { uiTranslated } from 'admin-panel/utils/model';

import type { TranslatedField } from 'admin-panel/constants/types';
import type GenreModel from 'admin-panel/models/genre';
import type HotelModel from 'admin-panel/models/hotel';
import type LocaleModel from 'admin-panel/models/locale';

export default class RoomControlTvChannelModel extends Model {
  @hasMany('genre')
  declare genres: AsyncHasMany<GenreModel>;

  @hasMany('hotel')
  declare hotels: AsyncHasMany<HotelModel>;

  @hasMany('locale')
  declare locales: AsyncHasMany<LocaleModel>;

  @attr
  declare titleTranslations: TranslatedField;

  @uiTranslated
  declare title: string;

  @attr
  declare abbreviation: string;

  @attr
  declare logoUrl: string;

  get logoSrc() {
    const url = this.logoUrl;
    if (!url) return '';
    return new URL(url, config.api.host).href;
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'room-control/tv-channel': RoomControlTvChannelModel;
  }
}
